import API from 'services/API';

export default function cancelAppointment(bookId) {
  return API.request({
    method: 'POST',
    url: `/appointment/cancelBooking?bookId=${bookId}`,
    data: {},
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
